export default __webpack_public_path__ + "static/media/waste-water.61c99e97.png";